import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';

import setRussianFilterName from 'utils/setRussianFilterName';
import { useStores } from 'hooks/useStores';
import CheckBold from 'ati-ui-react/components/icons/CheckBold';

import { addMetricSaveFilter } from 'utils/addMetrics';
import { SaveFilterBtnContainer, DescriptionBox, Description } from './SaveFilterBtnStyles';

const SaveFilterBtn = observer(() => {
  const {
    findTrucksStore: { countSearchFilters, getFormFieldsExistKeys, getFilterFields },
    saveFilterStore: {
      countFields,
      isFilterSave,
      filters,
      statusSavedFilter,
      isFilterExists,
      errorStatusSavedFilter,
      isShowPopoverHintFilter,
      postSaveFilter,
      setFilterSave,
      checkIsFilterExists,
      setPopoverHintFilterVisible,
    },
    notificationStore: { pushNotification },
    geoSearchStore,
    favoritesStore: { setPopoverHintFavoriteVisible, isShowPopoverHintFavorite },
  } = useStores();

  const countWhenShowLink = 2;

  const renderNotifications = (value: string) => {
    const values: { [key: string]: string } = {
      bad_request: 'Достигнуто максимальное количество фильтров для вашего контакта',
      service_unavailable:
        'Сервис недоступен. Перезагрузите, пожалуйста, страницу или зайдите позже.',
    };

    return values[value] ?? 'Ошибка при сохранении фильтра';
  };

  useEffect(() => {
    statusSavedFilter.default();
  }, []);

  useEffect(() => {
    getFormFieldsExistKeys();
    checkIsFilterExists();
    if (countFields < countWhenShowLink || filters.length === 0) {
      setFilterSave(false);
    }
  }, [filters.length]);

  useEffect(() => {
    if (statusSavedFilter.isFailure) {
      pushNotification(renderNotifications(errorStatusSavedFilter), 'error');
    }

    if (statusSavedFilter.isSuccess) {
      setFilterSave(true);
    }
  }, [statusSavedFilter.state]);

  useEffect(() => {
    return () => setPopoverHintFilterVisible(false);
  }, []);

  const onHandleSave = () => {
    if (isFilterExists || isFilterSave) return;
    if (filters.length === 0 && !window.localStorage.getItem('hint-filter-popover')) {
      setPopoverHintFilterVisible(true);
      setPopoverHintFavoriteVisible(false);
    }
    const filter = {
      search_params: getFilterFields(),
      filter_name: setRussianFilterName(getFilterFields()?.advert_item_type),
      query_string: window.location.search,
      ...(geoSearchStore.value && { geo_text: geoSearchStore.value }),
    };

    postSaveFilter(filter);
    addMetricSaveFilter(filter);
  };

  const renderDescription = () => {
    if (isFilterExists && !isFilterSave) {
      return <span className="no-pointer">Поиск уже сохранен</span>;
    }

    if (!isFilterSave || filters.length === 0 || statusSavedFilter.isFailure) {
      return 'Сохранить поиск';
    }

    if (isFilterSave) {
      return (
        <span className="no-pointer">
          <CheckBold width="14" height="10" color="#478cc8" className="check-icon" />
          Поиск сохранен
        </span>
      );
    }

    return null;
  };

  return (
    <>
      {countSearchFilters >= countWhenShowLink && (
        <SaveFilterBtnContainer>
          <DescriptionBox onClick={onHandleSave}>
            <Description className="description">{renderDescription()}</Description>
          </DescriptionBox>
        </SaveFilterBtnContainer>
      )}
    </>
  );
});

export default SaveFilterBtn;
